// import MyAlert from './my-alert';
// import {sidebar} from './sidebar'
import { SidebarWebComponent } from './webcomponent-sidebar';
import  {  bonusDefRowSchema } from "@bonusmap/api-types";
import { Delegate, type EventCallback, type DelegatedEvent } from '@bonusmap/shared_ui/library';
// Entry point per il bundle del tema
const themeJS = {
  bonusDefRowSchema
  // sidebar,
  // MyAlert
};
SidebarWebComponent.registerElement();
document.addEventListener('DOMContentLoaded', () => {
  // Inizializza la sidebar al caricamento del DOM
  // themeJS.sidebar();
});
// Esportazione dei moduli
export { themeJS };
// Esportazione del Delegate per renderlo disponibile a runtime
export { Delegate, type EventCallback, type DelegatedEvent };
// Esportazione di tutti i moduli necessari
export default {};
// Se vuoi esportare anche altri moduli, aggiungili qui
// export * from './altro-modulo'

// Esportazione di default se necessario
// export { default as Sidebar } from './sidebar'
